module.exports = __webpack_public_path__ + "img/book_zhineng.3b6635ec.png";